module.exports = __webpack_public_path__ + "img/cm_on.2240a895.png";